/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationInvoicesGetInvoiceResponse { 
    id?: number;
    number?: string | null;
    companyId?: number;
    companyName?: string | null;
    customerId?: string | null;
    customerName?: string | null;
    subject?: string | null;
    date?: string;
    invoicingName?: string | null;
    invoicingAddress1?: string | null;
    invoicingAddress2?: string | null;
    invoicingPostalCode?: string | null;
    invoicingCity?: string | null;
    invoicingCountryId?: string | null;
    deliveryName?: string | null;
    deliveryAddress1?: string | null;
    deliveryAddress2?: string | null;
    deliveryPostalCode?: string | null;
    deliveryCity?: string | null;
    deliveryCountryId?: string | null;
    isPaid?: boolean;
    paidDate?: string | null;
    amount?: number;
    userId?: string | null;
    salesRepresentativeName?: string | null;
}

